import React from "react";
import { Clock3 } from "lucide-react";

const PolicyDeskRailHead = ({ meta, icon }) => (
  <>
    <div className="pp-rail-nav">
      <div className="pp-rail-meta">
        <span>
          <Clock3 size={10} aria-hidden />
          {meta.readMinutes} min read
        </span>
        <span>Updated {meta.updatedAt}</span>
      </div>
    </div>

    <div className="pp-rail-hero">
      <span className="pp-rail-icon" aria-hidden>
        {icon}
      </span>
      <p className="pp-kicker">{meta.eyebrow}</p>
      <h1 className="pp-rail-title">{meta.title}</h1>
      <p className="pp-rail-summary">{meta.summary}</p>
    </div>
  </>
);

export default PolicyDeskRailHead;
